import { createModel, RematchDispatch } from '@rematch/core';
import produce from 'immer';
import { QuestionRequestType } from '../../types/question.type';

import { RootModel } from '../models';
import baseEntity from './base.entity';

import { getQuestionsByProjectKey } from '../../services/questions.service';
import { QuestionType } from '../../types/index';
import { storeName as layoutModelStore } from '../models/layout.model';
import { DEFAULT_API_LANGUAGE } from '../../commons/constants';

export const storeName = 'questionEntity';

export const questionEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: QuestionType[]) => {
      (entities || []).forEach((entity: QuestionType) => {
        state.ids[entity.code] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof questionEntity>) => ({
    async loadByKey(payload: QuestionRequestType, state: RootModel) {
      const { locale } = state[layoutModelStore];

      const resp = await getQuestionsByProjectKey({
        ...payload,
        language: locale?.apiLanguage || DEFAULT_API_LANGUAGE,
      });
      if (resp) {
        // TODO update Now filter group questions and question
        const questions = resp.filter((item) => item.answer);

        this.saves([...questions]);
        return questions;
      }

      return [];
    },
  }),
});

export default questionEntity;
